import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { JQLEditorReadOnly } from '../jql-editor-layout';

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null
    });

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.setState({
        error: error
      });
      this.props.onError && this.props.onError(error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          renderFallback = _this$props.render;
      var error = this.state.error;

      if (error === null) {
        return children;
      }

      return renderFallback({
        error: error
      });
    }
  }]);

  return ErrorBoundary;
}(Component);

export var withErrorBoundary = function withErrorBoundary(WrappedComponent) {
  return function (props) {
    var query = props.query,
        onRenderError = props.onRenderError,
        onSearch = props.onSearch,
        isCompact = props.isCompact;
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      onError: onRenderError,
      render: function render() {
        return /*#__PURE__*/React.createElement(JQLEditorReadOnly, {
          query: query,
          isSearch: !!onSearch,
          isCompact: isCompact
        });
      }
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
};